import { render, staticRenderFns } from "./FooterSettings.vue?vue&type=template&id=18f45b9f&"
import script from "./FooterSettings.vue?vue&type=script&lang=js&"
export * from "./FooterSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports